import { render, staticRenderFns } from "./ListaEtapa.vue?vue&type=template&id=3865b107&"
import script from "./ListaEtapa.vue?vue&type=script&lang=js&"
export * from "./ListaEtapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports